import { filter } from 'lodash'

// Given a doc or docs, strips out those that don't exist
export const onlyExisting = (given) =>
  Array.isArray(given) ? filter(given, 'exists') : given?.exists ? given : null
